export default __webpack_public_path__ + "static/who-we-are-1e961dd581fe1ace8cf985a8b7fc783b.jpg";